import { create } from "zustand";

type Loan = {
  id: string;
  totalAmountRequested: number;
  status: string;
  employeeName: string;
  employeeEmail: string;
} | null;

interface HookProps {
  open: boolean;
  loan: Loan;
  setLoan: (loan: Loan) => void;
  onOpenChange: (open: boolean) => void;
}

export const useTakeActionModal = create<HookProps>()((set) => ({
  open: false,
  loan: null,
  setLoan: (id) =>
    set(() => ({
      loan: id,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
